import { Style } from '@/includes/types/Post.types'

export function removeStyle(styles: Record<string, Style>, styleKey: string) {
        delete styles![styleKey]

        return styles
}